import type { SupportedLocale } from '@/shared/types/i18n';

const VENUE_RECORDS_KEY = ['metadata-library', 'environments', 'records'] as const;

export const venueKeys = {
  records: VENUE_RECORDS_KEY,
  recordsList: (q?: string, organizationIds?: readonly string[]) =>
    [...VENUE_RECORDS_KEY, 'infinite', q ?? '', organizationIds ?? []] as const,
  record: (recordId: string) => ['metadata-library', 'environments', 'record', recordId] as const,
  fields: (locale: SupportedLocale) =>
    ['metadata-library', 'environments', 'fields', locale] as const,
};
